<template>
  <div class="random-rewards-bind">
    <Transition
      name="page-transition"
      mode="out-in"
      appear
    >
      <template v-if="!participateProcess">
        <BindCardForm v-if="!isParticipant" />
        <BindCardSuccess v-else />
      </template>
      <div
          v-else
          class="quiz_template-place quiz_template-place__loading"
        >
        <Spinner size="medium" color="red"  />
      </div>
    </Transition>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Spinner from '@/common/components/Spinner.vue'
import BindCardForm from './BindCardForm'
import BindCardSuccess from './BindCardSuccess'

const randomRewards = namespace('randomRewards')

@Component({
  components: {
    BindCardForm,
    BindCardSuccess,
    Spinner
  }
})
class BindCard extends Vue {
  @randomRewards.Action('participate') participate
  @randomRewards.State('isParticipant') isParticipant
  @randomRewards.State('participateProcess') participateProcess

  maskTokens = { F: { pattern: /[0-9a-zA-Z]/, transform: v => v.toUpperCase() } }
  inputValue = ''
}

export default BindCard
</script>

<style lang="scss">
  .random-rewards-bind {
    &_wrapper {
      padding: 32px 30px;
      box-sizing: border-box;
      @include media_desktop {
        padding: 80px;
      }
      &__bound {
        padding-bottom: 50px;
      }
    }
    &_text {
      max-width: 600px;
    }
    &_attention {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: #CCCCCC;
      margin-top: 30px;
      @include media_desktop {
        font-size: 20px;
        line-height: 25px;
      }
    }
    &_bound {
      display: flex;
      align-items: center;
      margin-top: 50px;
    }
    &_bound-description-head {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 21px;
      color: #999999;
      margin-bottom: 4px;
    }
    &_bound-description-card {
      font-style: normal;
      font-weight: normal;
      font-size: 20px;
      line-height: 25px;
      color: #666666;
    }
    &_form {
      border-top: 1px solid #333;
      border-bottom: 1px solid #333;
      padding: 30px 17px;
      display: grid;
      grid-template-columns: 1fr min-content ;
      grid-template-areas: 'input info' 'error error';
      @include media_tablet {
        padding: 30px;
      }
      @include media_desktop {
        /* autoprefixer: off */
        padding: 30px 80px;
        grid-template-columns: min-content min-content 1fr;
        grid-template-areas: 'input info error';
        justify-items: start;
        align-items: center;
      }
      &__error {
        .random-rewards-bind_input::placeholder {
          color: #FF8000;
        }
      }
      &__bound {
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 25px;
        color: #3BB200;
        display: block;
      }
    }
    &_input {
      border: none;
      background: none;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;
      height: 20px;
      color: #999999;
      width: 162px;
      padding: 0;
      grid-area: input;
      @include media_desktop {
        font-size: 20px;
        line-height: 20px;
      }
    }
    &_info {
      margin-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      grid-area: info;
      &-hint {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 15px 20px;
        position: absolute;
        max-width: 340px;
        width: 75vw;
        left: auto;
        right: 100%;
        top: 100%;
        background: #FFFFFF;
        box-shadow: 0px 12px 24px #000000;
        border-radius: 10px;
        z-index: 1;
        font-family: $font-roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 20px;
        color: #333333;
        opacity: 0;
        transition: opacity .3s ease;
        pointer-events: none;
        @include media_desktop {
          left: 100%;
          right: auto;
        }
        img {
          margin-top: 15px;
        }
      }
    }
    &_error {
      grid-area: error;
      font-style: normal;
      font-weight: normal;
      color: #FF8000;
      margin-top: 16px;
      background: rgba(0, 0, 0, 0.7);
      border-radius: 10px;
      border: 1px solid #FF8000;
      padding: 8px 16px;
      font-size: 12px;
      line-height: 16px;
      @include media_desktop {
        font-size: 20px;
        line-height: 25px;
        padding: 16px 24px;
        margin-left: 50px;
        margin-top: 0;
      }
    }
    &_buttons {
      display: flex;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      @include media_tablet {
        display: block;
      }
      .ml20 {
        margin-left: 0;
        @include media_tablet {
          margin-left: 20px;
        }
      }
      .button {
        margin-top: 10px;
        @include media_tablet {
          margin-top: 0;
        }
        &:first-child {
          margin-top: 0;
        }
      }
    }
    svg {
      width: 16px;
      height: 16px;
      @include media_tablet {
        width: 25px;
        height: 25px;
      }
    }
  }
  .random-rewards-bind_info:hover {
    .random-rewards-bind_info-hint {
      opacity: 1;
    }
  }
</style>
